/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './alert.tpl.html';

/**
 * Module that contains artifacts associated with the mobile alert.
 */
angular
  .module('mobile.alert', [])
  /**
   *  Controller for the mobileAlert directive. It is shown by emitting the rootScope event
   *  MOBILE_EVENT.SHOW_MOBILE_ALERT.  The parameter passed to that event should be an object that
   *  has two properties: msg and sub.  The msg value will be the larger top text and the sub will
   *  be the small sub message.
   */
  .controller('MobileAlertCtrl', function ($scope, $rootScope, $timeout, DELAYS, MOBILE_EVENTS) {
    $scope.showAlert = false;
    $scope.msg = '';
    $scope.sub = '';

    /**
     * Hide the alert if shown.
     */
    $scope.hideAlert = function () {
      $scope.showAlert = false;
    };

    /**
     * Add the rootScope event listener for displaying the alert. If the alert is already shown
     * hide it.
     */
    $rootScope.$on(MOBILE_EVENTS.SHOW_MOBILE_ALERT, function (evtObj, alertCfg) {
      // Only show if not currently shown.
      if (!$scope.showAlert) {
        $scope.msg = alertCfg.msg || '';
        $scope.sub = alertCfg.sub || '';
        $scope.showAlert = true;
        $timeout($scope.hideAlert, DELAYS.HIDE_MOBILE_ALERT);
      } else {
        // If showing hide it.
        $scope.hideAlert();
      }
    });

    // Listen for the state change events and hide the alert on any state change
    $rootScope.$on('$stateChangeStart', function () {
      $scope.hideAlert();
    });
  })
  /**
   *  Directive used to show a simple mobile alert.
   */
  .directive('mobileAlert', function () {
    return {
      templateUrl: 'mobile/alert/alert.tpl.html',
      controller: 'MobileAlertCtrl'
    };
  });
